/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_125_TitleInputs */

const en_tree_type_125_title = /** @type {(inputs: Tree_Type_125_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dancing Lady Orchid`)
};

const ar_tree_type_125_title = /** @type {(inputs: Tree_Type_125_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سيدة الأوركيد الراقصة`)
};

const de_tree_type_125_title = /** @type {(inputs: Tree_Type_125_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tänzelnde Frauenorchidee`)
};

const es_tree_type_125_title = /** @type {(inputs: Tree_Type_125_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dama danzante`)
};

const fr_tree_type_125_title = /** @type {(inputs: Tree_Type_125_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oncidium`)
};

const it_tree_type_125_title = /** @type {(inputs: Tree_Type_125_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lady Orchidea Danzante`)
};

const ja_tree_type_125_title = /** @type {(inputs: Tree_Type_125_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オンシジウム`)
};

const ko_tree_type_125_title = /** @type {(inputs: Tree_Type_125_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`춤추는 여인 난초`)
};

const pt_br_tree_type_125_title = /** @type {(inputs: Tree_Type_125_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orquídea bailarina`)
};

const ru_tree_type_125_title = /** @type {(inputs: Tree_Type_125_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Онцидиум`)
};

const th_tree_type_125_title = /** @type {(inputs: Tree_Type_125_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กล้วยไม้ตุ๊กตาเริงระบำ`)
};

const tr_tree_type_125_title = /** @type {(inputs: Tree_Type_125_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dans Eden Orkide Hanım`)
};

const zh_cn_tree_type_125_title = /** @type {(inputs: Tree_Type_125_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文心兰`)
};

const zh_tw_tree_type_125_title = /** @type {(inputs: Tree_Type_125_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文心蘭`)
};

/**
* | output |
* | --- |
* | "Dancing Lady Orchid" |
*
* @param {Tree_Type_125_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_125_title = /** @type {((inputs?: Tree_Type_125_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_125_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_125_title(inputs)
	if (locale === "ar") return ar_tree_type_125_title(inputs)
	if (locale === "de") return de_tree_type_125_title(inputs)
	if (locale === "es") return es_tree_type_125_title(inputs)
	if (locale === "fr") return fr_tree_type_125_title(inputs)
	if (locale === "it") return it_tree_type_125_title(inputs)
	if (locale === "ja") return ja_tree_type_125_title(inputs)
	if (locale === "ko") return ko_tree_type_125_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_125_title(inputs)
	if (locale === "ru") return ru_tree_type_125_title(inputs)
	if (locale === "th") return th_tree_type_125_title(inputs)
	if (locale === "tr") return tr_tree_type_125_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_125_title(inputs)
	return zh_tw_tree_type_125_title(inputs)
});